import { createStructuredSelector } from 'reselect'

import {
  ASSESSMENT_CATEGORY_LIST,
  ASSESSMENT_CATEGORY_LIST_SUCCESS, 
  ASSESSMENT_CATEGORY_LIST_ERROR,
  ASSESSMENT_CATEGORY_PAGE_SET,
  ASSESSMENT_CATEGORY_SEARCH_SET,
  ASSESSMENT_CATEGORY_SEARCH_CHANGE,
  ASSESSMENT_CATEGORY_ADD_SET,
  ASSESSMENT_CATEGORY_ADD_MODAL_SET,
  ASSESSMENT_CATEGORY_ADD,
  ASSESSMENT_CATEGORY_ADD_SUCCESS,
  ASSESSMENT_CATEGORY_ADD_ERROR,
  ASSESSMENT_CATEGORY_ADD_CHANGE,
  ASSESSMENT_CATEGORY_DETAIL,
  ASSESSMENT_CATEGORY_DETAIL_SUCCESS,
  ASSESSMENT_CATEGORY_DETAIL_ERROR,
  ASSESSMENT_CATEGORY_VIEW_MODAL_SET,
  ASSESSMENT_CATEGORY_EDIT_CHANGE,
  ASSESSMENT_CATEGORY_EDIT_MODAL_SET,
  ASSESSMENT_CATEGORY_UPDATE,
  ASSESSMENT_CATEGORY_UPDATE_SUCCESS,
  ASSESSMENT_CATEGORY_UPDATE_ERROR,
  ASSESSMENT_CATEGORY_VIEW_TAB_SET
} from '../../actions';

export const NAME = 'assessment_category';

export const AssessmentCategoryList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: ASSESSMENT_CATEGORY_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const AssessmentCategoryListSuccess = (data) => ({
  type: ASSESSMENT_CATEGORY_LIST_SUCCESS,
  payload: data
});

export const AssessmentCategoryListError = (error) => ({
  type: ASSESSMENT_CATEGORY_LIST_ERROR,
  payload: error
});

export const AssessmentCategoryPageSet = (data) => ({
  type: ASSESSMENT_CATEGORY_PAGE_SET,
  payload: data
});

export const AssessmentCategorySearchSet = (data) => ({
  type: ASSESSMENT_CATEGORY_SEARCH_SET,
  payload: data
});

export const AssessmentCategorySearchChangeSet = (data) => ({
  type: ASSESSMENT_CATEGORY_SEARCH_CHANGE,
  payload: data
});

export const AssessmentCategoryAddChangeSet = (data) => ({
  type: ASSESSMENT_CATEGORY_ADD_CHANGE,
  payload: data
});

export const AssessmentCategoryAddSet = (data) => ({
  type: ASSESSMENT_CATEGORY_ADD_SET,
  payload: data
});

export const AssessmentCategoryAddModalSet = (data) => ({
  type: ASSESSMENT_CATEGORY_ADD_MODAL_SET,
  payload: data
});

export const AssessmentCategoryAdd = (data) => ({
  type: ASSESSMENT_CATEGORY_ADD,
  payload: data
});

export const AssessmentCategoryAddSuccess = (message) => ({
  type: ASSESSMENT_CATEGORY_ADD_SUCCESS,
  payload: message
});

export const AssessmentCategoryAddError = (error) => ({
  type: ASSESSMENT_CATEGORY_ADD_ERROR,
  payload: error
});

export const AssessmentCategoryDetail = (data) => ({
  type: ASSESSMENT_CATEGORY_DETAIL,
  payload: data
});

export const AssessmentCategoryDetailSuccess = (data) => ({
  type: ASSESSMENT_CATEGORY_DETAIL_SUCCESS,
  payload: data
});

export const AssessmentCategoryDetailError = (error) => ({
  type: ASSESSMENT_CATEGORY_DETAIL_ERROR,
  payload: error
});

export const AssessmentCategoryViewModalSet = (data) => ({
  type: ASSESSMENT_CATEGORY_VIEW_MODAL_SET,
  payload: data
});

export const AssessmentCategoryEditModalSet = (data) => ({
  type: ASSESSMENT_CATEGORY_EDIT_MODAL_SET,
  payload: data
});

export const AssessmentCategoryEditChangeSet = (data) => ({
  type: ASSESSMENT_CATEGORY_EDIT_CHANGE,
  payload: data
});

export const AssessmentCategoryUpdate = (data) => ({
  type: ASSESSMENT_CATEGORY_UPDATE,
  payload: data
});

export const AssessmentCategoryUpdateSuccess = (message) => ({
  type: ASSESSMENT_CATEGORY_UPDATE_SUCCESS,
  payload: message.message
});

export const AssessmentCategoryUpdateError = (error) => ({
  type: ASSESSMENT_CATEGORY_UPDATE_ERROR,
  payload: error
});

export const AssessmentCategoryViewTabSet = (data) => ({
  type: ASSESSMENT_CATEGORY_VIEW_TAB_SET,
  payload: data
});


const assessment_category = (state) => state[NAME];

export const AssessmentCategorySelector = createStructuredSelector({
  assessment_category
})
 